import React, { useContext } from 'react';
import DomainData from '../../assets/datasets/DomainData';
import { TrackingContext } from '../context/Tracking';
import PlacesAutoComplete from '../forms/PlacesAutoComplete';
import SelectField from '../forms/SelectField';
import Filter from './Filter';
import Menu from './Menu';

const countFilters = (filter) => {
  let count = 0;
  if (filter.departments.length > 0) count++;
  return count;
};

const MapFilter = ({ mapInstance, mapApi, setCenter, setZoom, setCenterAndZoomIn, setFilter, filter, forceFilterOpen, setForceFilterOpen, openWizard }) => {
  const [menuOpen, setMenuOpen] = React.useState(null);
  const [filterOpen, setFilterOpen] = React.useState(forceFilterOpen);
  const [search, setSearch] = React.useState('');
  const { t } = useContext(TrackingContext);
  const small = window.innerWidth < 500;

  React.useEffect(() => {
    if (filterOpen !== null) t('action', filterOpen ? 'open_filter' : 'close_filter');
  }, [filterOpen]);

  React.useEffect(() => {
    if (menuOpen !== null) t('action', menuOpen ? 'open_menu' : 'close_menu');
  }, [menuOpen]);

  const howManyFiltersSet = countFilters(filter);

  const filterOpenOverall = (forceFilterOpen || filterOpen);

  return (
    <>
      <div
        className='search-filter'
        style={{
          top: small ? 10 : 20,
          left: small ? 10 : 20,
          zIndex: 1000,
          position: 'fixed',
          background: 'white',
          paddingTop: 12,
          paddingBottom: 12,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: 12,
          width: small ? window.innerWidth - 20 : 450,
          boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.1)'
        }}
      >

        <table style={{ width: '100%', verticalAlign: 'middle', height: 50 }}>
          <tbody>
            <tr>
              <td style={{
                width: 40,
                paddingRight: 15,
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}
              >
                <center><a onClick={() => setMenuOpen(!menuOpen)}><i className='fa fa-user' style={{ fontSize: 28, textDecoration: 'none' }} /></a></center>
              </td>
              {
               filterOpenOverall
                 ? (
                   <td><div style={{ width: '100%' }}>Filter setzen</div></td>
                   )
               /*  : howManyFiltersSet > 0
                   ? (<td><b>{howManyFiltersSet} Filter gesetzt</b></td>) */
                 : (
                   <td>
                     <PlacesAutoComplete
                       name='map_filter_places'
                       map={mapInstance}
                       mapApi={mapApi}
                       setCenter={setCenter}
                       setZoom={setZoom}
                       setCenterAndZoomIn={(c, z) => { setSearch(old => { t('action', 'city_search', old); setCenterAndZoomIn(c, z); return old; }); }}
                       setValue={setSearch}
                       value={search}
                       style={{ marginBottom: 0 }}
                       small
                     />
                   </td>
                   )
              }
              <td style={{ textAlign: 'right', cursor: 'pointer', paddingLeft: 15 }}>
                <a onClick={() => { setFilterOpen(!filterOpen); setForceFilterOpen(filterOpen ? false : null); }}><i className={filterOpenOverall ? 'fa fa-arrow-up' : 'fa fa-arrow-down'} />&nbsp;&nbsp;&nbsp;</a>
              </td>
            </tr>

            {/* {
  howManyFiltersSet > 0 && (
    <tr>
      <td>&nbsp;</td>
      <td><p style={{ fontSize: 12, margin: 0, textAlign: 'right' }}>+{filter.departments.length} Fachgebiet(e)</p></td>
      <td>&nbsp;</td>
    </tr>
  )
  } */}
          </tbody>
        </table>

        <div style={{ position: 'relative' }}>
          {
            menuOpen && (
              <Menu openWizard={openWizard} close={() => setMenuOpen(false)} left={10} top={-12} />
            )
          }
        </div>
        {
          filterOpenOverall
            ? (
              <Filter
                {...{ setFilter, filter, search, setSearch }}
              />
              )
            : (
              <>
              </>
              )
        }
        {/* <SelectField
          options={DomainData.areasOfExpertise}
          multi
          value={filter.departments}
          setValue={newDepartments => { setFilter('departments', newDepartments); }}
          style={{
            height: 42,
            border: '0.5px solid rgba(115, 115, 115, 0.4)',
            borderRadius: 6,
            fontSize: 16
          }}
        /> */}
      </div>
    </>
  );
};

export default MapFilter;
